import React, { useState } from "react";
import "./customForm.css";
import creatorImage from "../../assets/creatorBilal.jpg";
import Calculate from "../calculate/calculate";
import FinalDrop from "../finalDrop/finalDrop";
import "bootstrap/dist/css/bootstrap.min.css";
import Device from "../device/device";

const CustomForm = () => {
  const [dropdownValue, setDropdownValue] = useState("");
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [multiplier, setMultiplier] = useState(0);
  const [showFinalDrop, setShowFinalDrop] = useState(false);
  const [showForm, setShowForm] = useState(true);

  const handleMultiplierChange = (calculatedMultiplier) => {
    setMultiplier(calculatedMultiplier);
  };

  const isFormValid = () => {
    return input1.trim() !== "" && input2.trim() !== "" && dropdownValue !== "";
  };

  const isDropDownValid = () => {
    return dropdownValue.trim() !== "";
  };



  const handleCheckAgainClick = () => {
    setShowFinalDrop(false); // FinalDrop'u gizle
    setShowForm(true); // Formu tekrar göster
    // Gerekirse form alanlarını sıfırlayabilirsiniz:
    setInput1("");
    setInput2("");
    setInput3("");
    setDropdownValue("");
  };

  // Validation function for input1 based on dropdown selection
  const handleValidation = (value) => {
    let isValid = true;
    let error = "";

    // Ensure input1 contains only numbers
    if (isNaN(value) || value === "") {
      isValid = false;
      error = "Amount must be a number.";
    }

    // Add custom validation based on dropdown value
    switch (dropdownValue) {
      case "Item 2":
        if (parseInt(value) > 10000) {
          isValid = false;
          error = "Amount cannot exceed 10,000 when Level 2 is selected.";
        }
        break;
      case "Item 3":
        if (parseInt(value) > 30000) {
          isValid = false;
          error = "Amount cannot exceed 30,000 when Level 3 is selected.";
        }
        break;
      case "Item 4":
        if (parseInt(value) > 100000) {
          isValid = false;
          error = "Amount cannot exceed 100,000 when Level 4 is selected.";
        }
        break;
        case "Item 5":
        if (parseInt(value) > 250000) {
          isValid = false;
          error = "Amount cannot exceed 100,000 when Level 5 is selected.";
        }
        break;
      case "Item 6":
        if (parseInt(value) > 500000) {
          isValid = false;
          error = "Amount cannot exceed 500,000 when Level 6 is selected.";
        }
        break;
      default:
        break;
    }

    setErrorMessage(error);
    return isValid;
  };

  // Input1 değiştiğinde validation kontrolü yapılır
  const handleInput1Change = (e) => {
    const value = e.target.value;
    if (handleValidation(value)) {
      setInput1(value);
    } else {
      setInput1(""); // Hatalı giriş varsa input sıfırlanır
    }
  };

  // Form submit olduğunda verileri konsola yazdırıyoruz
  const handleSubmit = (e) => {
    e.preventDefault();
    if (errorMessage === "") {
      console.log("Selected Level:", dropdownValue);
      console.log("Point Input:", input1);
      console.log("Social Input 2:", input2);
      console.log("Social Input 3:", input3);
      setShowFinalDrop(true);
      setShowForm(false);
    } else {
      alert("Please correct the errors before submitting.");
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="alert alert-primary shadow" role="alert">
        Phaver Season 2 Airdrop Calculator
      </h2>

      {showForm && (
        <form className="shadow p-2 mb-2 bg-body-tertiary rounded" onSubmit={handleSubmit}>
          {/* Dropdown */}
          <div className="mb-3 customForm">
            <label className="form-label">Select Level</label>
            <select
              className="form-select"
              value={dropdownValue}
              onChange={(e) => setDropdownValue(e.target.value)}
            >
              <option value="">--Select your level--</option>
              <option value="Item 2">Level 2</option>
              <option value="Item 3">Level 3</option>
              <option value="Item 4">Level 4</option>
              <option value="Item 5">Level 5</option>
              <option value="Item 6">Level 6</option>
            </select>
          </div>

          {/* First input */}
          <div className="mb-3">
            <label className="form-label">
              Amount of points you want to burn
            </label>
            <input
              type="number"
              className="form-control"
              value={input1}
              onChange={handleInput1Change}
              placeholder="Enter the amount of points"
              disabled={!isDropDownValid()}
            />
            {/* Error Message  */}
            {errorMessage && <div className="text-danger">{errorMessage}</div>}
          </div>

          {/* Second Input */}
          <div className="mb-3">
            <label className="form-label">
              Average amount of $SOCIAL in your wallet
            </label>
            <input
              type="number"
              className="form-control"
              value={input2}
              onChange={(e) => setInput2(e.target.value)}
              placeholder="Enter Social amount"
              disabled={!isDropDownValid()}
            />

              <label className="form-label mt-3">
              This field is an estimate. It is the total share of all users that will be calculated at the end of 30 days. <br/> <b>For example 750000000 (750M)</b>
            </label>
            <input
              type="number"
              className="form-control"
              value={input3}
              onChange={(e) => setInput3(e.target.value)}
              placeholder="Enter the total share amount "
              disabled={!isDropDownValid()}
            />

            <Calculate
              input2={parseInt(input2)}
              onMultiplierChange={handleMultiplierChange}

            />
            <div className="currentMultiplier">
              <h4>Current Multiplier: {multiplier}</h4>
            </div>
          </div>
           

          {/* Buton */}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={!isFormValid()}
          >
            Check Your Airdrop
          </button>
        </form>
      )}
      {showFinalDrop && (
        <FinalDrop
          input1={parseInt(input1)}
          input3={parseInt(input3)}
          multiplier={multiplier}
          onCheckAgain={handleCheckAgainClick}
        />
      )}
      {showForm && (
        <div className="container text-center">
          <div className="row justify-content-md-center">
            <div className="col col-md-8">
              <img
                src={creatorImage}
                className="shadow img-fluid mt-5 rounded-5"
                alt="creator"
              />
            </div>
            <div class="d-grid col-md-8 mt-3">
              <Device/>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomForm;
